var FABRIC_DIALOG_CLOSE_EVENT = 'dialog:close';

document.addEventListener('click', function (e) {
  if (!(e.target instanceof Element)) return;
  var el = e.target.closest('[data-fabric-drawer-trigger]');
  if (!el) return;

  var hostId = el.getAttribute('data-fabric-drawer-host');
  var templateId = el.getAttribute('data-fabric-drawer-template');
  if (!hostId || !templateId) return;

  e.preventDefault();

  var host = document.getElementById(hostId);
  var tpl = document.getElementById(templateId);
  if (!host || !(tpl instanceof HTMLTemplateElement)) return;

  var mount = host.querySelector('[ref="fabricDrawerBody"]');
  if (!mount) return;

  /** @type {HTMLTemplateElement} */
  var fabricTplRef = tpl;
  /** @type {Element} */
  var fabricMountRef = mount;

  /** @returns {void} */
  function mountAndShowFabricDrawer() {
    fabricMountRef.replaceChildren(fabricTplRef.content.cloneNode(true));

    /** @returns {void} */
    function playVideos() {
      fabricMountRef.querySelectorAll('deferred-media[autoplay] > video').forEach(function (video) {
        if (video instanceof HTMLVideoElement) void video.play().catch(function () {});
      });
    }

    playVideos();

    var dialogHost = /** @type {HTMLElement & { showDialog?: () => void }} */ (host);
    if (typeof dialogHost.showDialog === 'function') {
      dialogHost.dataset.dialogOpenedWithPointer = e.detail === 0 ? 'false' : 'true';
      dialogHost.addEventListener('dialog:open', function () {
        requestAnimationFrame(playVideos);
      }, { once: true });
      dialogHost.showDialog();
    }
  }

  var pane = host.querySelector('dialog');
  if (
    pane instanceof HTMLDialogElement &&
    pane.open &&
    pane.classList.contains('dialog-closing')
  ) {
    host.addEventListener(FABRIC_DIALOG_CLOSE_EVENT, mountAndShowFabricDrawer, { once: true });
    return;
  }

  mountAndShowFabricDrawer();
});
